import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-72c9ddbc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "content",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = { class: "nav" }

import {
  Icon, Navbar, RouteSearchMap, LatLng, MapPort,
} from '@components';
import { Route } from '@components/types/api';


export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceMapOverlay',
  props: {
    isOpen: { type: Boolean },
    closeCallback: { type: Function },
    center: {},
    ports: {},
    routes: {}
  },
  emits: ['routeItemClick'],
  setup(__props: any) {






return (_ctx: any,_cache: any) => {
  return (_ctx.isOpen)
    ? (_openBlock(), _createBlock(_Teleport, {
        key: 0,
        to: "body"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              class: "closeBtn",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeCallback && _ctx.closeCallback(...args)))
            }, [
              _createVNode(_unref(Icon), {
                "icon-name": "close",
                lg: ""
              })
            ]),
            _createVNode(_unref(Navbar), {
              header: _ctx.$t('Service map')
            }, null, 8, ["header"])
          ]),
          _createVNode(_unref(RouteSearchMap), {
            center: _ctx.center,
            ports: _ctx.ports,
            routes: _ctx.routes,
            "is-status-map": true,
            onOnRouteItemClick: _cache[1] || (_cache[1] = (routeCode) => _ctx.$emit('routeItemClick', routeCode))
          }, null, 8, ["center", "ports", "routes"]),
          _createElementVNode("button", {
            class: "srOnly",
            onKeydown: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.closeCallback && _ctx.closeCallback(...args)), ["tab"]))
          }, " Close overlay ", 32)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})